export default {
    init() {

        this.feefoSlider = $('.feefo-slider')

        if (this.feefoSlider.length) {
            this.initSlider()
        }
    },
    initSlider() {

        this.feefoSlider.slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            rows: 0,
            adaptiveHeight: true,
            prevArrow: '<button type="button" class="slick-arrow slick-arrow--prev"><i class="fal fa-2x fa-angle-left"></i></button>',
            nextArrow: '<button type="button" class="slick-arrow slick-arrow--next"><i class="fal fa-2x fa-angle-right"></i></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        })

    },
};
